/* =============================================================================
   DTF Gangsheet Builder — script.js
   Vanilla JS + Fabric.js (self-hosted, assets/fabric.min.js). No jQuery.

   WORDPRESS INTEGRATION NOTES
   ---------------------------
   • All business settings live in GSB_CONFIG below (sizes, price-per-inch,
     currency, DPI, product name). In WP you can print an inline
     `window.GSB_SETTINGS = {...}` before this file to override any key.
   • "Save & Add to Cart" calls window.GSB_ON_ADD_TO_CART(payload) if defined —
     point it at your WooCommerce AJAX add-to-cart endpoint. Without a hook it
     downloads the print-ready PNG so the builder is fully testable standalone.
   • Enqueue fabric.min.js + this file with `defer`, ONLY on the builder page.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------ CONFIG --------------------------------- */

  var GSB_CONFIG = {
    sheetWidthIn: 36,                  // DTF gang sheet roll width (inches)
    // Sheet length options. price:null => computed as h * pricePerLinearInch.
    // The section overrides these with each size's exact price + variant id.
    sizes: [
      { h: 12 },  { h: 24 },  { h: 36 },  { h: 48 },  { h: 60 },  { h: 72 },
      { h: 84 },  { h: 96 },  { h: 108 }, { h: 120 }, { h: 132 }, { h: 144 },
      { h: 156 }, { h: 168 }, { h: 180 }, { h: 192 }, { h: 204 }, { h: 240 },
      { h: 300 }, { h: 350 }, { h: 400 }, { h: 500 }, { h: 750 }, { h: 1000 }
    ],
    pricePerLinearInch: 0.65,          // $46.80 / 72in — matches the reference site
    currency: '$',
    productName: 'DTF Gangsheet',
    defaultSizeH: 72,                  // preselected size (22" x 72")
    assumedDPI: 300,                   // uploaded pixel size -> physical inches
    exportDPI: 300,                    // print file DPI (auto-capped for browser safety)
    exportMaxPixels: 40e6,             // cap so toDataURL cannot crash the tab
    cartMaxSidePx: 1400,               // cap the cart preview's longest side (px) so /cart/add.js doesn't 413
    uploadGapIn: 0.2,                  // spacing used when flow-placing uploads
    maxAutoFillItems: 500,             // safety cap for auto-fill / bulk duplicate
    maxUndo: 30
  };
  // Allow WordPress (wp_localize_script / inline script) to override settings:
  if (window.GSB_SETTINGS) {
    Object.keys(window.GSB_SETTINGS).forEach(function (k) { GSB_CONFIG[k] = window.GSB_SETTINGS[k]; });
  }

  var U   = 100;                       // internal model units per inch
  var EPS = 1;                         // 0.01in tolerance for spacing checks

  if (!window.fabric) {
    console.error('[GSB] fabric.min.js not loaded — check assets/fabric.min.js path.');
    return;
  }

  /* ------------------------------ DOM refs ------------------------------- */

  var $ = function (id) { return document.getElementById(id); };
  var el = {
    sizeSelect: $('gsbSizeSelect'), startOver: $('gsbStartOver'),
    undo: $('gsbUndo'), redo: $('gsbRedo'), selectAll: $('gsbSelectAll'),
    alignLeft: $('gsbAlignLeft'), alignCenter: $('gsbAlignCenter'), alignRight: $('gsbAlignRight'),
    duplicateOne: $('gsbDuplicateOne'), rotate: $('gsbRotate'), del: $('gsbDelete'),
    zoomOut: $('gsbZoomOut'), zoomIn: $('gsbZoomIn'), zoomRange: $('gsbZoomRange'),
    price: $('gsbPrice'), addToCart: $('gsbAddToCart'), addToCart2: $('gsbAddToCart2'),
    drop: $('gsbDrop'), uploadBtn: $('gsbUploadBtn'), fileInput: $('gsbFileInput'),
    gallery: $('gsbGallery'),
    duplicateMany: $('gsbDuplicateMany'), autoFill: $('gsbAutoFill'),
    ruler: $('gsbRuler'), scroll: $('gsbScroll'), stage: $('gsbStage'),
    modal: $('gsbModal'), modalTitle: $('gsbModalTitle'), modalText: $('gsbModalText'),
    modalOk: $('gsbModalOk'), modalCancel: $('gsbModalCancel'), toast: $('gsbToast')
  };

  // The host theme re-creates these number inputs after init, orphaning any
  // cached reference. Expose them as live getters so reads/writes hit the DOM.
  [['w', 'gsbW'], ['h', 'gsbH'], ['dupQty', 'gsbDupQty'], ['margin', 'gsbMargin']].forEach(function (p) {
    Object.defineProperty(el, p[0], { get: function () { return document.getElementById(p[1]); } });
  });

  /* ------------------------------ State ---------------------------------- */

  var state = {
    sizeIdx: 0,
    zoomPct: 100,        // 100% == fit sheet width to viewport
    fitScale: 1,         // canvas px per model unit at 100%
    undoStack: [],
    redoStack: [],
    restoring: false
  };
  var srcRegistry = Object.create(null);  // gsbSrcId -> dataURL (keeps undo snapshots tiny)
  var srcCounter = 0;
  var activeSrc = null;                    // the gallery image the sidebar acts on
  var lastRatio = null;                    // width/height of the active/last image -> keeps W&H proportional even before an image is placed
  var toastTimer = null;

  /* --------------------------- Fabric canvas ----------------------------- */

  fabric.Object.prototype.set({
    borderColor: '#2563eb',
    cornerColor: '#ffffff',
    cornerStrokeColor: '#2563eb',
    cornerSize: 9,
    touchCornerSize: 24,
    transparentCorners: false,
    borderScaleFactor: 1.5,
    objectCaching: false
  });
  // Default serialization rounds scaleX/scaleY to 2 decimals -> undo/redo would
  // drift image sizes (2.00in becomes 1.98in). Keep full precision:
  fabric.Object.NUM_FRACTION_DIGITS = 8;

  var canvas = new fabric.Canvas('gsbCanvas', {
    selection: true,
    preserveObjectStacking: true,
    uniformScaling: true,
    selectionColor: 'rgba(37, 99, 235, 0.08)',
    selectionBorderColor: '#2563eb',
    selectionLineWidth: 1.5,
    backgroundColor: ''               // transparent — checkerboard shows through
  });

  function sheetW() { return GSB_CONFIG.sheetWidthIn; }
  function sheetH() { return GSB_CONFIG.sizes[state.sizeIdx].h; }
  function sheetWU() { return sheetW() * U; }
  function sheetHU() { return sheetH() * U; }
  function sizePrice(s) {
    return (s.price != null) ? s.price : +(s.h * GSB_CONFIG.pricePerLinearInch);
  }
  function money(n) { return GSB_CONFIG.currency + n.toFixed(2); }

  /* ------------------------------ Toast/modal ---------------------------- */

  function toast(msg, ms) {
    el.toast.textContent = msg;
    el.toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.toast.hidden = true; }, ms || 2800);
  }

  var modalOkHandler = null;
  function confirmBox(title, text, okLabel, onOk) {
    el.modalTitle.textContent = title;
    el.modalText.textContent = text;
    el.modalOk.textContent = okLabel;
    modalOkHandler = onOk;
    el.modal.hidden = false;
    el.modalCancel.focus();
  }
  el.modalCancel.addEventListener('click', function () { el.modal.hidden = true; modalOkHandler = null; });
  el.modal.addEventListener('click', function (e) { if (e.target === el.modal) { el.modal.hidden = true; modalOkHandler = null; } });
  el.modalOk.addEventListener('click', function () {
    el.modal.hidden = true;
    if (modalOkHandler) { var fn = modalOkHandler; modalOkHandler = null; fn(); }
  });

  /* ------------------------------ Zoom & layout -------------------------- */

  var MAX_CANVAS_PX = 15000;

  function computeFit() {
    var avail = Math.max(el.scroll.clientWidth - 2, 200);
    state.fitScale = avail / sheetWU();
  }

  function applyZoom(pct) {
    pct = Math.min(300, Math.max(10, pct));
    var s = state.fitScale * (pct / 100);
    // guard: don't let the backing canvas explode on very long sheets
    var maxS = MAX_CANVAS_PX / Math.max(sheetWU(), sheetHU());
    if (s > maxS) { s = maxS; pct = Math.round((s / state.fitScale) * 100); }
    state.zoomPct = pct;
    el.zoomRange.value = String(pct);

    var wPx = Math.round(sheetWU() * s);
    var hPx = Math.round(sheetHU() * s);
    canvas.setDimensions({ width: wPx, height: hPx });
    canvas.setZoom(s);
    el.stage.style.width = wPx + 'px';
    el.stage.style.height = hPx + 'px';
    canvas.calcOffset();
    canvas.requestRenderAll();
    drawRuler();
  }

  /* ------------------------------ Ruler ---------------------------------- */

  function drawRuler() {
    var dpr = window.devicePixelRatio || 1;
    var cssW = el.scroll.clientWidth;
    var cssH = 26;
    el.ruler.width = Math.round(cssW * dpr);
    el.ruler.height = Math.round(cssH * dpr);
    el.ruler.style.width = cssW + 'px';
    el.ruler.style.height = cssH + 'px';

    var ctx = el.ruler.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cssW, cssH);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, cssW, cssH);

    var s = canvas.getZoom();
    var pxPerIn = s * U;
    // Position of the sheet's left edge relative to the ruler canvas
    var originX = el.stage.getBoundingClientRect().left - el.scroll.getBoundingClientRect().left;

    var labelEvery = pxPerIn >= 48 ? 1 : pxPerIn >= 24 ? 2 : pxPerIn >= 10 ? 5 : 10;
    var minorStep = pxPerIn >= 96 ? 0.125 : pxPerIn >= 48 ? 0.25 : pxPerIn >= 24 ? 0.5 : 0;

    ctx.strokeStyle = '#9ca3af';
    ctx.fillStyle = '#374151';
    ctx.lineWidth = 1;
    ctx.font = '9px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif';
    ctx.textBaseline = 'top';

    var maxIn = sheetW();
    var first = Math.max(0, Math.floor((0 - originX) / pxPerIn));
    var last  = Math.min(maxIn, Math.ceil((cssW - originX) / pxPerIn));

    ctx.beginPath();
    for (var i = first; i <= last; i++) {
      var x = Math.round(originX + i * pxPerIn) + 0.5;
      if (i % labelEvery === 0) {
        ctx.moveTo(x, cssH); ctx.lineTo(x, cssH - 14);
        ctx.fillText(i + ' in', x + 3, 3);
      } else {
        ctx.moveTo(x, cssH); ctx.lineTo(x, cssH - 8);
      }
      if (minorStep && i < maxIn) {
        for (var f = minorStep; f < 1 - 1e-6; f += minorStep) {
          var xm = Math.round(originX + (i + f) * pxPerIn) + 0.5;
          var h = (Math.abs(f - 0.5) < 1e-6) ? 8 : 5;
          ctx.moveTo(xm, cssH); ctx.lineTo(xm, cssH - h);
        }
      }
    }
    ctx.stroke();
  }

  /* ------------------------------ Price ----------------------------------- */

  function updatePrice() {
    var s = GSB_CONFIG.sizes[state.sizeIdx];
    el.price.textContent = money(sizePrice(s)) + ' • ' + s.h.toFixed(2) + ' in • ' + GSB_CONFIG.productName;
  }

  /* --------------------------- Geometry helpers --------------------------- */

  function bboxOf(obj) { return obj.getBoundingRect(true, true); }

  function objectRects(exclude) {
    var rects = [];
    canvas.getObjects().forEach(function (o) {
      if (o === exclude) return;
      var b = bboxOf(o);
      rects.push({ left: b.left, top: b.top, right: b.left + b.width, bottom: b.top + b.height });
    });
    return rects;
  }

  function intersects(a, rects) {
    for (var i = 0; i < rects.length; i++) {
      var r = rects[i];
      if (a.left < r.right && a.right > r.left && a.top < r.bottom && a.bottom > r.top) return true;
    }
    return false;
  }

  function findFreeSpot(wU, hU, gapU, rects) {
    if (wU > sheetWU() || hU > sheetHU()) return null;
    if (!rects.length) return { left: 0, top: 0 };
    var step = 25; // 0.25in scan grid
    var rows = (sheetHU() - hU) / step, cols = (sheetWU() - wU) / step;
    if (rows * cols > 40000) step = 50;
    var pad = Math.max(0, gapU - EPS);
    for (var y = 0; y + hU <= sheetHU() + EPS; y += step) {
      for (var x = 0; x + wU <= sheetWU() + EPS; x += step) {
        var cand = { left: x - pad, top: y - pad, right: x + wU + pad, bottom: y + hU + pad };
        if (!intersects(cand, rects)) return { left: x, top: y };
      }
    }
    return null;
  }

  // Grid of candidate cells (pitch = size + margin) that don't collide with existing art
  function freeGridCells(wU, hU, mU, rects, maxCells) {
    var cells = [];
    var pad = Math.max(0, mU - EPS);
    // Start one margin in from the top-left and stop one margin before the
    // right/bottom edges, so the grid keeps an even margin all the way around
    // the sheet — not just between items.
    for (var y = mU; y + hU + mU <= sheetHU() + EPS; y += hU + mU) {
      for (var x = mU; x + wU + mU <= sheetWU() + EPS; x += wU + mU) {
        var cand = { left: x - pad, top: y - pad, right: x + wU + pad, bottom: y + hU + pad };
        if (!intersects(cand, rects)) {
          cells.push({ left: x, top: y });
          if (cells.length >= maxCells) return cells;
        }
      }
    }
    return cells;
  }

  function clampToSheet(obj) {
    var b = bboxOf(obj);
    var f = Math.min(1, sheetWU() / b.width, sheetHU() / b.height);
    if (f < 1) {
      obj.scaleX *= f; obj.scaleY *= f;
      obj.setCoords();
      b = bboxOf(obj);
    }
    var dx = 0, dy = 0;
    if (b.left < 0) dx = -b.left;
    if (b.top < 0) dy = -b.top;
    if (b.left + b.width > sheetWU()) dx = sheetWU() - (b.left + b.width);
    if (b.top + b.height > sheetHU()) dy = sheetHU() - (b.top + b.height);
    if (dx || dy) {
      obj.left += dx; obj.top += dy;
      obj.setCoords();
    }
  }

  // Scroll the canvas viewport so a freshly-placed object is visible.
  function scrollIntoView(obj) {
    try {
      var b = bboxOf(obj);
      var z = canvas.getZoom();
      var topPx = b.top * z;
      var botPx = (b.top + b.height) * z;
      var viewTop = el.scroll.scrollTop;
      var viewH = el.scroll.clientHeight;
      if (topPx < viewTop || botPx > viewTop + viewH) {
        el.scroll.scrollTop = Math.max(0, topPx - 30);
      }
    } catch (e) {}
  }

  /* ------------------------- Undo / redo history -------------------------- */

  function serializeNow() {
    var j = canvas.toJSON(['gsbSrcId']);
    (j.objects || []).forEach(function (o) {
      if (o.gsbSrcId != null && o.src) o.src = 'gsb-src://' + o.gsbSrcId;
    });
    return { json: JSON.stringify(j), sizeIdx: state.sizeIdx };
  }

  function saveState() {
    if (state.restoring) return;
    state.undoStack.push(serializeNow());
    if (state.undoStack.length > GSB_CONFIG.maxUndo) state.undoStack.shift();
    state.redoStack.length = 0;
    updateHistoryButtons();
  }

  function loadState(snap, done) {
    state.restoring = true;
    if (snap.sizeIdx !== state.sizeIdx) {
      state.sizeIdx = snap.sizeIdx;
      el.sizeSelect.value = String(snap.sizeIdx);
      computeFit(); applyZoom(state.zoomPct); updatePrice();
    }
    var parsed = JSON.parse(snap.json);
    (parsed.objects || []).forEach(function (o) {
      if (o.src && o.src.indexOf('gsb-src://') === 0) {
        o.src = srcRegistry[o.src.slice('gsb-src://'.length)] || '';
      }
    });
    canvas.loadFromJSON(parsed, function () {
      canvas.getObjects().forEach(function (o) { o.set({ objectCaching: false }); });
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      state.restoring = false;
      syncDimInputs();
      updateHistoryButtons();
      if (done) done();
    });
  }

  function undo() {
    if (state.undoStack.length < 2) return;
    state.redoStack.push(state.undoStack.pop());
    loadState(state.undoStack[state.undoStack.length - 1]);
    updateHistoryButtons();
  }

  function redo() {
    if (!state.redoStack.length) return;
    var snap = state.redoStack.pop();
    state.undoStack.push(snap);
    loadState(snap);
    updateHistoryButtons();
  }

  function updateHistoryButtons() {
    el.undo.disabled = state.undoStack.length < 2;
    el.redo.disabled = !state.redoStack.length;
  }

  /* --------------------------- Size handling ------------------------------ */

  function populateSizes() {
    var def = 0;
    GSB_CONFIG.sizes.forEach(function (s, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = sheetW() + 'x' + s.h;
      el.sizeSelect.appendChild(opt);
      if (s.h === GSB_CONFIG.defaultSizeH) def = i;
    });
    state.sizeIdx = def;
    el.sizeSelect.value = String(def);
  }

  function onSizeChange() {
    state.sizeIdx = parseInt(el.sizeSelect.value, 10) || 0;
    computeFit();
    applyZoom(state.zoomPct);
    canvas.getObjects().forEach(clampToSheet);
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    updatePrice();
    saveState();
  }

  /* --------------------------- Image handling ----------------------------- */

  function registerSrc(dataURL) {
    var id = String(++srcCounter);
    srcRegistry[id] = dataURL;
    return id;
  }

  function addImageFromDataURL(dataURL, done) {
    var id = registerSrc(dataURL);
    fabric.Image.fromURL(dataURL, function (img) {
      img.set({ gsbSrcId: id, objectCaching: false });
      // Physical size: uploaded pixels at assumedDPI, capped to the sheet
      var wIn = img.width / GSB_CONFIG.assumedDPI;
      var hIn = img.height / GSB_CONFIG.assumedDPI;
      var scale = (wIn * U) / img.width;                 // == U/assumedDPI
      var fit = Math.min(1, sheetW() / wIn, sheetH() / hIn);
      scale *= fit;
      img.scaleX = img.scaleY = scale;
      img.setCoords();

      var b = bboxOf(img);
      var gap = GSB_CONFIG.uploadGapIn * U;
      var spot = findFreeSpot(b.width, b.height, gap, objectRects(img));
      if (!spot) {
        spot = { left: 0, top: 0 };
        toast('No free space left — choose a larger sheet size.');
      }
      img.set({ left: spot.left + (img.left - b.left), top: spot.top + (img.top - b.top) });
      img.setCoords();
      canvas.add(img);
      canvas.setActiveObject(img);
      canvas.requestRenderAll();
      scrollIntoView(img);
      done && done(img);
    }, { crossOrigin: 'anonymous' });
  }

  // Uploaded images land in the sidebar gallery (like the reference), NOT the
  // canvas. Clicking a thumbnail places that image on the sheet.
  function addToGallery(dataURL) {
    var g = el.gallery;
    if (!g) { addImageFromDataURL(dataURL, function () { saveState(); }); return; }
    g.hidden = false;
    activeSrc = dataURL;
    var item = document.createElement('div');
    item.className = 'gsb-gallery-item';
    item.title = 'Click to add to the sheet';
    var im = document.createElement('img');
    im.alt = 'Uploaded design'; im.draggable = false;
    // Auto-fill the sidebar Width/Height with this image's placement size as
    // soon as it's uploaded (before it's even placed on the sheet).
    im.onload = function () {
      var wIn = im.naturalWidth / GSB_CONFIG.assumedDPI;
      var hIn = im.naturalHeight / GSB_CONFIG.assumedDPI;
      if (im.naturalHeight) lastRatio = im.naturalWidth / im.naturalHeight;
      var fit = Math.min(1, sheetW() / wIn, sheetH() / hIn);
      if (el.w && el.h) {
        el.w.disabled = el.h.disabled = false;
        el.w.value = (wIn * fit).toFixed(2);
        el.h.value = (hIn * fit).toFixed(2);
      }
    };
    im.src = dataURL;
    var del = document.createElement('button');
    del.type = 'button'; del.className = 'gsb-gallery-del';
    del.innerHTML = '&times;'; del.setAttribute('aria-label', 'Remove image');
    item.appendChild(im); item.appendChild(del);
    item.addEventListener('click', function (e) {
      if (e.target === del) {
        item.remove();
        if (!g.children.length) g.hidden = true;
        return;
      }
      activeSrc = dataURL;
      addImageFromDataURL(dataURL, function () { saveState(); });
    });
    g.appendChild(item);
  }

  function handleFiles(fileList) {
    var files = Array.prototype.slice.call(fileList || []);
    var ok = files.filter(function (f) { return /^image\/(png|jpe?g|webp)$/i.test(f.type); });
    if (files.length && !ok.length) { toast('Unsupported file — use PNG, WebP or JPEG.'); return; }
    if (files.length !== ok.length) toast('Some files skipped — only PNG, WebP, JPEG are supported.');
    if (!ok.length) return;

    var i = 0;
    (function next() {
      if (i >= ok.length) { toast('Added to your images — click a thumbnail to place it on the sheet.'); return; }
      var reader = new FileReader();
      reader.onload = function () { addToGallery(reader.result); i++; next(); };
      reader.onerror = function () { toast('Could not read ' + ok[i].name); i++; next(); };
      reader.readAsDataURL(ok[i]);
    })();
  }

  // Fast clone that reuses the already-decoded <img> element (no re-decode)
  function cloneImage(src, left, top) {
    var copy = new fabric.Image(src.getElement(), {
      left: left != null ? left : src.left,
      top: top != null ? top : src.top,
      scaleX: src.scaleX, scaleY: src.scaleY,
      angle: src.angle, flipX: src.flipX, flipY: src.flipY,
      gsbSrcId: src.gsbSrcId,
      objectCaching: false
    });
    return copy;
  }

  /* ------------------------ Selection-driven UI --------------------------- */

  function activeObj() { return canvas.getActiveObject(); }

  function syncDimInputs() {
    var a = activeObj();
    if (!a) {
      el.w.value = ''; el.h.value = '';
      el.w.disabled = el.h.disabled = true;
      return;
    }
    var b = bboxOf(a);
    if (b.height) lastRatio = b.width / b.height;
    el.w.disabled = el.h.disabled = false;
    el.w.value = (b.width / U).toFixed(2);
    el.h.value = (b.height / U).toFixed(2);
  }

  function aspectLocked() {
    var cb = document.getElementById('gsbLockAspect');
    return !cb || cb.checked;   // default: locked
  }

  function applyDimInput(which) {
    var a = activeObj();
    var val = parseFloat(which === 'w' ? el.w.value : el.h.value);
    if (!a) {
      if (isFinite(val) && val > 0.05 && aspectLocked() && lastRatio) {
        if (which === 'w') el.h.value = (val / lastRatio).toFixed(2);
        else el.w.value = (val * lastRatio).toFixed(2);
      }
      return;
    }
    if (!isFinite(val) || val <= 0.05) { syncDimInputs(); return; }
    if (aspectLocked()) {
      // Uniform: the other dimension follows to preserve the aspect ratio.
      if (which === 'w') a.scaleToWidth(Math.min(val, sheetW()) * U, true);
      else a.scaleToHeight(Math.min(val, sheetH()) * U, true);
    } else {
      // Independent: only the edited dimension changes (may distort).
      if (which === 'w') a.scaleX = (Math.min(val, sheetW()) * U) / a.width;
      else a.scaleY = (Math.min(val, sheetH()) * U) / a.height;
    }
    a.setCoords();
    clampToSheet(a);
    canvas.requestRenderAll();
    syncDimInputs();
    saveState();
  }

  // Live proportional update while the user is still typing in a W/H box.
  // Scales the image and fills the OPPOSITE box (never the one being typed, so
  // we don't fight the caret) — no undo snapshot; the change event commits.
  function liveDimInput(which) {
    var a = activeObj();
    var val = parseFloat(which === 'w' ? el.w.value : el.h.value);
    if (!isFinite(val) || val <= 0.05) return;
    // No image selected on the sheet yet (still in the gallery): keep the two
    // boxes proportional using the uploaded image's ratio, so W and H track.
    if (!a) {
      if (aspectLocked() && lastRatio) {
        if (which === 'w') el.h.value = (val / lastRatio).toFixed(2);
        else el.w.value = (val * lastRatio).toFixed(2);
      }
      return;
    }
    if (aspectLocked()) {
      if (which === 'w') a.scaleToWidth(Math.min(val, sheetW()) * U, true);
      else a.scaleToHeight(Math.min(val, sheetH()) * U, true);
    } else {
      if (which === 'w') a.scaleX = (Math.min(val, sheetW()) * U) / a.width;
      else a.scaleY = (Math.min(val, sheetH()) * U) / a.height;
      a.setCoords();
    }
    clampToSheet(a);
    canvas.requestRenderAll();
    var b = bboxOf(a);
    if (which === 'w') el.h.value = (b.height / U).toFixed(2);
    else el.w.value = (b.width / U).toFixed(2);
  }

  /* ------------------------------ Actions --------------------------------- */

  function requireSource(msg) {
    var a = activeObj();
    if (a && a.type === 'activeSelection') {
      toast('Select a single image for this action.');
      return null;
    }
    if (!a) {
      var objs = canvas.getObjects();
      if (objs.length === 1) return objs[0];
      toast(msg || 'Select an image first.');
      return null;
    }
    return a;
  }

  function duplicateSelection() {
    var a = activeObj();
    if (!a) { toast('Select an image to duplicate.'); return; }
    var offs = 0.25 * U;
    var clones = [];
    var parts = (a.type === 'activeSelection') ? a.getObjects().slice() : [a];
    canvas.discardActiveObject();
    parts.forEach(function (o) {
      var c = cloneImage(o, o.left + offs, o.top + offs);
      canvas.add(c);
      clampToSheet(c);
      clones.push(c);
    });
    var sel = clones.length === 1 ? clones[0]
      : new fabric.ActiveSelection(clones, { canvas: canvas });
    canvas.setActiveObject(sel);
    canvas.requestRenderAll();
    syncDimInputs();
    saveState();
  }

  // A single usable source object on the canvas, or 'multi' for a multi-select,
  // or null if the sheet has nothing to act on.
  function singleSource() {
    var a = activeObj();
    if (a && a.type === 'activeSelection') return 'multi';
    if (a) return a;
    var objs = canvas.getObjects();
    if (objs.length === 1) return objs[0];
    return null;
  }

  // Grid-place up to maxN copies of a gallery image (dataURL) at the sidebar
  // Width/Height size, flowing around anything already on the sheet.
  function gridPlaceFromSrc(dataURL, maxN, mU, done) {
    var wVal = parseFloat(el.w.value), hVal = parseFloat(el.h.value);
    var id = registerSrc(dataURL);
    fabric.Image.fromURL(dataURL, function (master) {
      if (!master) { done && done(0); return; }
      master.set({ gsbSrcId: id, objectCaching: false });
      var natW = master.width / GSB_CONFIG.assumedDPI, natH = master.height / GSB_CONFIG.assumedDPI;
      var fit = Math.min(1, sheetW() / natW, sheetH() / natH);
      var targetWU = ((isFinite(wVal) && wVal > 0) ? Math.min(wVal, sheetW()) : natW * fit) * U;
      var targetHU = ((isFinite(hVal) && hVal > 0) ? Math.min(hVal, sheetH()) : natH * fit) * U;
      master.scaleX = targetWU / master.width;
      master.scaleY = targetHU / master.height;
      master.left = 0; master.top = 0; master.setCoords();
      var b = bboxOf(master);
      var cells = freeGridCells(b.width, b.height, mU, objectRects(null), Math.max(1, maxN));
      if (!cells.length) { toast('No room on this sheet — pick a larger size or smaller margin.'); done && done(0); return; }
      cells.forEach(function (cell) {
        canvas.add(cloneImage(master, cell.left + (master.left - b.left), cell.top + (master.top - b.top)));
      });
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      if (el.scroll) { el.scroll.scrollTop = 0; }
      saveState();
      done && done(cells.length);
    }, { crossOrigin: 'anonymous' });
  }

  function duplicateMany() {
    var qty = Math.max(1, Math.min(GSB_CONFIG.maxAutoFillItems, parseInt(el.dupQty.value, 10) || 1));
    var mU = Math.max(0, parseFloat(el.margin.value) || 0) * U;
    var src = singleSource();
    if (src === 'multi') { toast('Select a single image for this action.'); return; }
    if (src) {
      var b = bboxOf(src);
      var cells = freeGridCells(b.width, b.height, mU, objectRects(null), qty);
      if (!cells.length) { toast('No room for duplicates — pick a larger sheet or smaller margin.'); return; }
      cells.forEach(function (cell) {
        canvas.add(cloneImage(src, cell.left + (src.left - b.left), cell.top + (src.top - b.top)));
      });
      if (cells.length < qty) toast('Only ' + cells.length + ' of ' + qty + ' copies fit on this sheet.');
      canvas.requestRenderAll();
      saveState();
      return;
    }
    if (activeSrc) {
      gridPlaceFromSrc(activeSrc, qty, mU, function (n) {
        if (n && n < qty) toast('Only ' + n + ' of ' + qty + ' copies fit on this sheet.');
      });
      return;
    }
    toast('Upload an image first.');
  }

  function autoFillSheet() {
    var mU = Math.max(0, parseFloat(el.margin.value) || 0) * U;
    var src = singleSource();
    if (src === 'multi') { toast('Select a single image for this action.'); return; }
    if (src) {
      var b = bboxOf(src);
      var cells = freeGridCells(b.width, b.height, mU, objectRects(null), GSB_CONFIG.maxAutoFillItems);
      if (!cells.length) { toast('Sheet is already full.'); return; }
      cells.forEach(function (cell) {
        canvas.add(cloneImage(src, cell.left + (src.left - b.left), cell.top + (src.top - b.top)));
      });
      canvas.requestRenderAll();
      toast('Added ' + cells.length + ' copies.');
      saveState();
      return;
    }
    if (activeSrc) {
      gridPlaceFromSrc(activeSrc, GSB_CONFIG.maxAutoFillItems, mU, function (n) {
        if (n) toast('Added ' + n + ' copies.');
      });
      return;
    }
    toast('Upload an image first.');
  }

  /* ----------------------- Auto Build (settings modal) -------------------- */

  function setSizeByIndex(i) {
    i = Math.max(0, Math.min(GSB_CONFIG.sizes.length - 1, i | 0));
    el.sizeSelect.value = String(i);
    onSizeChange();
  }

  // Clear the sheet and lay out `qty` copies of one image at wIn×hIn with margin.
  function buildAutoLayout(opts, done) {
    opts = opts || {};
    if (!opts.dataURL) { done && done(0); return; }
    canvas.discardActiveObject();
    canvas.remove.apply(canvas, canvas.getObjects().slice());
    var id = registerSrc(opts.dataURL);
    fabric.Image.fromURL(opts.dataURL, function (img) {
      if (!img) { done && done(0); return; }
      img.set({ gsbSrcId: id, objectCaching: false });
      var wU = Math.min(Math.max(0.1, opts.wIn || 1), sheetW()) * U;
      var hU = Math.min(Math.max(0.1, opts.hIn || 1), sheetH()) * U;
      img.scaleX = wU / img.width;
      img.scaleY = hU / img.height;
      img.left = 0; img.top = 0; img.setCoords();
      var mU = Math.max(0, opts.marginIn || 0) * U;
      var maxN = Math.max(1, Math.min(GSB_CONFIG.maxAutoFillItems, opts.qty | 0));
      // Auto-rotate 90° when the portrait orientation packs more copies onto the
      // sheet (fits vertically instead of leaving space / wasting film).
      var cellsN = freeGridCells(wU, hU, mU, [], maxN);
      var cellsR = freeGridCells(hU, wU, mU, [], maxN);
      var rotated = cellsR.length > cellsN.length;
      if (rotated) { img.angle = 90; img.setCoords(); }
      var b = bboxOf(img);
      var cells = rotated ? cellsR : cellsN;
      if (!cells.length) {
        img.left = 0; img.top = 0; img.setCoords();
        canvas.add(img); clampToSheet(img);
      } else {
        cells.forEach(function (cell) {
          canvas.add(cloneImage(img, cell.left + (img.left - b.left), cell.top + (img.top - b.top)));
        });
      }
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      if (el.scroll) { el.scroll.scrollTop = 0; el.scroll.scrollLeft = 0; }
      syncDimInputs();
      saveState();
      done && done(cells.length || 1);
    }, { crossOrigin: 'anonymous' });
  }

  function deleteSelection() {
    var a = activeObj();
    if (!a) { toast('Select an image to delete.'); return; }
    var parts = (a.type === 'activeSelection') ? a.getObjects().slice() : [a];
    canvas.discardActiveObject();
    parts.forEach(function (o) { canvas.remove(o); });
    canvas.requestRenderAll();
    syncDimInputs();
    saveState();
  }

  // Rotate one object 90° about its own centre so it stays put on the sheet.
  function rotate90(o) {
    var c = o.getCenterPoint();
    o.angle = ((o.angle || 0) + 90) % 360;
    o.setPositionByOrigin(c, 'center', 'center');
    o.setCoords();
    clampToSheet(o);
  }
  function rotateSelection() {
    var a = activeObj();
    if (!a) { toast('Select an image to rotate.'); return; }
    if (a.type === 'activeSelection') {
      var parts = a.getObjects().slice();
      canvas.discardActiveObject();   // parts return to canvas coords
      parts.forEach(rotate90);
    } else {
      rotate90(a);
    }
    canvas.requestRenderAll();
    syncDimInputs();
    saveState();
  }

  function selectAll() {
    var objs = canvas.getObjects();
    if (!objs.length) return;
    canvas.discardActiveObject();
    var sel = objs.length === 1 ? objs[0] : new fabric.ActiveSelection(objs, { canvas: canvas });
    canvas.setActiveObject(sel);
    canvas.requestRenderAll();
    syncDimInputs();
  }

  function align(mode) {
    var a = activeObj();
    if (!a) { toast('Select an image to align.'); return; }
    var b = bboxOf(a);
    var target = mode === 'left' ? 0
      : mode === 'center' ? (sheetWU() - b.width) / 2
      : sheetWU() - b.width;
    a.left += target - b.left;
    a.setCoords();
    canvas.requestRenderAll();
    saveState();
  }

  function startOver() {
    confirmBox('Start over?', 'This will remove every image from the sheet.', 'Yes, start over', function () {
      canvas.discardActiveObject();
      canvas.remove.apply(canvas, canvas.getObjects().slice());
      canvas.requestRenderAll();
      syncDimInputs();
      saveState();
      toast('Sheet cleared.');
    });
  }

  /* --------------------------- Save / export ------------------------------ */

  function getLayout() {
    var s = GSB_CONFIG.sizes[state.sizeIdx];
    return {
      sheet: { widthIn: sheetW(), heightIn: s.h, variantId: s.variant || null },
      price: sizePrice(s),
      currency: GSB_CONFIG.currency,
      items: canvas.getObjects().map(function (o) {
        var b = bboxOf(o);
        return {
          srcId: o.gsbSrcId || null,
          xIn: +(b.left / U).toFixed(3),
          yIn: +(b.top / U).toFixed(3),
          widthIn: +(b.width / U).toFixed(3),
          heightIn: +(b.height / U).toFixed(3),
          angle: +(o.angle || 0).toFixed(2)
        };
      })
    };
  }

  function addToCart() {
    if (!canvas.getObjects().length) { toast('Add at least one image to the sheet first.'); return; }
    toast('Preparing print-ready file…', 6000);
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    setTimeout(function () {
      var wIn = sheetW(), hIn = sheetH();
      // Cap the exported PNG so Shopify's /cart/add.js accepts it. A full sheet
      // at print DPI is many MB and the request is rejected with 413, so limit
      // the longest side too — this attachment is a cart preview.
      var maxSideDpi = GSB_CONFIG.cartMaxSidePx / Math.max(wIn, hIn);
      var dpi = Math.min(
        GSB_CONFIG.exportDPI,
        Math.floor(Math.sqrt(GSB_CONFIG.exportMaxPixels / (wIn * hIn))),
        Math.floor(maxSideDpi)
      );
      if (dpi < 20) dpi = 20;
      var mult = (dpi / U) / canvas.getZoom();
      var dataURL = canvas.toDataURL({ format: 'png', multiplier: mult });
      var payload = { layout: getLayout(), dpi: dpi, dataURL: dataURL };

      if (typeof window.GSB_ON_ADD_TO_CART === 'function') {
        window.GSB_ON_ADD_TO_CART(payload);       // WooCommerce hook point
        return;
      }
      var a = document.createElement('a');
      a.href = dataURL;
      a.download = 'gangsheet-' + wIn + 'x' + hIn + '-' + dpi + 'dpi.png';
      document.body.appendChild(a);
      a.click();
      a.remove();
      toast('Print file downloaded (' + dpi + ' DPI). Hook GSB_ON_ADD_TO_CART for WooCommerce.', 4200);
    }, 60);
  }

  /* ------------------------------ Wiring ---------------------------------- */

  // Upload triggers
  el.uploadBtn.addEventListener('click', function (e) { e.stopPropagation(); el.fileInput.click(); });
  el.drop.addEventListener('click', function () { el.fileInput.click(); });
  el.drop.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.fileInput.click(); }
  });
  el.fileInput.addEventListener('change', function () { handleFiles(el.fileInput.files); el.fileInput.value = ''; });

  ['dragenter', 'dragover'].forEach(function (evt) {
    el.drop.addEventListener(evt, function (e) { e.preventDefault(); el.drop.classList.add('gsb-dragover'); });
    el.scroll.addEventListener(evt, function (e) { e.preventDefault(); });
  });
  ['dragleave', 'drop'].forEach(function (evt) {
    el.drop.addEventListener(evt, function (e) { e.preventDefault(); el.drop.classList.remove('gsb-dragover'); });
  });
  el.drop.addEventListener('drop', function (e) { handleFiles(e.dataTransfer.files); });
  el.scroll.addEventListener('drop', function (e) { e.preventDefault(); handleFiles(e.dataTransfer.files); });

  // Toolbar
  el.undo.addEventListener('click', undo);
  el.redo.addEventListener('click', redo);
  el.selectAll.addEventListener('click', selectAll);
  el.alignLeft.addEventListener('click', function () { align('left'); });
  el.alignCenter.addEventListener('click', function () { align('center'); });
  el.alignRight.addEventListener('click', function () { align('right'); });
  el.duplicateOne.addEventListener('click', duplicateSelection);
  if (el.rotate) el.rotate.addEventListener('click', rotateSelection);
  el.del.addEventListener('click', deleteSelection);
  el.startOver.addEventListener('click', startOver);
  el.sizeSelect.addEventListener('change', onSizeChange);

  // Sidebar
  // Delegated on the document — the theme re-creates these inputs, so a listener
  // bound directly to the node at init would be lost when it's replaced.
  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.id === 'gsbW') applyDimInput('w');
    else if (e.target.id === 'gsbH') applyDimInput('h');
    else if (e.target.id === 'gsbLockAspect') { canvas.uniformScaling = e.target.checked; }
  });
  // Live: as soon as one box is typed, the other follows proportionally.
  document.addEventListener('input', function (e) {
    if (!e.target) return;
    if (e.target.id === 'gsbW') liveDimInput('w');
    else if (e.target.id === 'gsbH') liveDimInput('h');
  });
  el.duplicateMany.addEventListener('click', duplicateMany);
  el.autoFill.addEventListener('click', autoFillSheet);
  el.addToCart.addEventListener('click', addToCart);
  el.addToCart2.addEventListener('click', addToCart);

  // Zoom
  el.zoomRange.addEventListener('input', function () { applyZoom(parseInt(el.zoomRange.value, 10)); });
  el.zoomOut.addEventListener('click', function () { applyZoom(state.zoomPct - 10); });
  el.zoomIn.addEventListener('click', function () { applyZoom(state.zoomPct + 10); });

  // Canvas events
  canvas.on('selection:created', syncDimInputs);
  canvas.on('selection:updated', syncDimInputs);
  canvas.on('selection:cleared', syncDimInputs);
  canvas.on('object:moving', function (e) { clampToSheet(e.target); });
  canvas.on('object:modified', function (e) {
    if (e.target) clampToSheet(e.target);
    canvas.requestRenderAll();
    syncDimInputs();
    saveState();
  });

  // Keyboard shortcuts (ignored while typing in a field)
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'SELECT' || t.tagName === 'TEXTAREA')) return;
    var mod = e.ctrlKey || e.metaKey;
    if (mod && e.key.toLowerCase() === 'z' && !e.shiftKey) { e.preventDefault(); undo(); }
    else if ((mod && e.key.toLowerCase() === 'y') || (mod && e.shiftKey && e.key.toLowerCase() === 'z')) { e.preventDefault(); redo(); }
    else if (mod && e.key.toLowerCase() === 'a') { e.preventDefault(); selectAll(); }
    else if (mod && e.key.toLowerCase() === 'd') { e.preventDefault(); duplicateSelection(); }
    else if (e.key === 'Delete' || e.key === 'Backspace') {
      if (activeObj()) { e.preventDefault(); deleteSelection(); }
    } else if (/^Arrow/.test(e.key) && activeObj()) {
      e.preventDefault();
      var d = (e.shiftKey ? 1 : 0.1) * U;
      var a = activeObj();
      if (e.key === 'ArrowLeft') a.left -= d;
      if (e.key === 'ArrowRight') a.left += d;
      if (e.key === 'ArrowUp') a.top -= d;
      if (e.key === 'ArrowDown') a.top += d;
      clampToSheet(a);
      canvas.requestRenderAll();
    }
  });
  document.addEventListener('keyup', function (e) {
    if (/^Arrow/.test(e.key) && activeObj()) saveState();
  });

  // Ruler follows scrolling / resizing
  el.scroll.addEventListener('scroll', drawRuler, { passive: true });
  if (window.ResizeObserver) {
    new ResizeObserver(function () {
      var pct = state.zoomPct;
      computeFit();
      applyZoom(pct);
    }).observe(el.scroll);
  } else {
    window.addEventListener('resize', function () { computeFit(); applyZoom(state.zoomPct); });
  }

  /* ------------------------------ Init ------------------------------------ */

  populateSizes();
  computeFit();
  applyZoom(100);
  updatePrice();
  syncDimInputs();
  saveState();          // baseline state for undo

  // Debug / integration handle (used by tests and future WP glue code)
  window.GSB = {
    canvas: canvas,
    config: GSB_CONFIG,
    getLayout: getLayout,
    state: state,
    version: '1.0.0',
    setSizeByIndex: setSizeByIndex,
    buildAutoLayout: buildAutoLayout
  };
})();
